export const FETCH_AUTH_TEST = 'Auth/FETCH_AUTH_TEST';
export const FETCH_AUTH_TEST_SUCCESS = 'Auth/FETCH_AUTH_TEST_SUCCESS';
export const FETCH_AUTH_TEST_FAILURE = 'Auth/FETCH_AUTH_TEST_FAILURE';

export const FETCH_LOGIN = 'Auth/FETCH_LOGIN';
export const FETCH_LOGIN_SUCCESS = 'Auth/FETCH_LOGIN_SUCCESS';
export const FETCH_LOGIN_FAILURE = 'Auth/FETCH_LOGIN_FAILURE';

export const FETCH_LOGOUT = 'Auth/FETCH_LOGOUT';
export const FETCH_LOGOUT_SUCCESS = 'Auth/FETCH_LOGOUT_SUCCESS';
export const FETCH_LOGOUT_FAILURE = 'Auth/FETCH_LOGOUT_FAILURE';

export const FETCH_FORGOT_PASSWORD = 'Auth/FETCH_FORGOT_PASSWORD';
export const FETCH_FORGOT_PASSWORD_SUCCESS = 'Auth/FETCH_FORGOT_PASSWORD_SUCCESS';
export const FETCH_FORGOT_PASSWORD_FAILURE = 'Auth/FETCH_FORGOT_PASSWORD_FAILURE';

export const FETCH_RESET_PASSWORD = 'Auth/FETCH_RESET_PASSWORD';
export const FETCH_RESET_PASSWORD_SUCCESS = 'Auth/FETCH_RESET_PASSWORD_SUCCESS';
export const FETCH_RESET_PASSWORD_FAILURE = 'Auth/FETCH_RESET_PASSWORD_FAILURE';
export const CLEAR_RESET_PASSWORD_FORM = 'Auth/CLEAR_RESET_PASSWORD_FORM';
export const UPDATE_RESET_PASSWORD_FORM = 'Auth/UPDATE_RESET_PASSWORD_FORM';

export const FETCH_NEW_USER = 'Auth/FETCH_NEW_USER';
export const FETCH_NEW_USER_SUCCESS = 'Auth/FETCH_NEW_USER_SUCCESS';
export const FETCH_NEW_USER_FAILURE = 'Auth/FETCH_NEW_USER_FAILURE';

export const CLEAR_ERROR = 'Auth/CLEAR_ERROR';
export const CLEAR_USER = 'Auth/CLEAR_USER';
export const EMPTY_AUTH = 'Auth/EMPTY_AUTH';
export const UPDATE_AUTH = 'Auth/UPDATE_AUTH';
export const UPDATE_CREDENTIALS = 'Auth/UPDATE_CREDENTIALS';
export const UPDATE_USER = 'Auth/UPDATE_USER';
export const UPDATE_USER_ADMIN_EMAIL = 'Auth/UPDATE_USER_ADMIN_EMAIL';
export const UPDATE_USER_ROLE = 'Auth/UPDATE_USER_ROLE';



// WEBPACK FOOTER //
// ./src/containers/AuthPages/store/constants.js